import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { withApollo } from 'react-apollo'
import auth from '../auth'
import logo from '../assets/img/MessagePlus_logo.png'

import {
  Input,
  Button,
  Warning,
  NavLink,
  Notification
} from '../components'


class Login extends Component {
  state = {
    error: null,
    email: '',
    password: '',
    redirectToReferrer: false
  }

  UNSAFE_componentWillMount() {
    setTimeout(() => { this.props.client.resetStore() }, 0)  // solution proposed in https://github.com/apollographql/apollo-client/issues/1945 to solve "Network error: Store reset while query was in flight."
  }

  login = (authChannel) => {
    this.setState({ error: false })
    auth.login(this.state.email, this.state.password, (loggedIn, error) => {
      if (loggedIn) {
        this.setState({ redirectToReferrer: true })
      } else {
        if ((error instanceof TypeError) && (error.message === "Failed to fetch")) {
          this.setState({
            error: <Notification type="error" message="Login failed due to connectivity issues.  Please try again." closeIcon={false} />
          })
        } else {
          this.setState({ error: "Sorry, could not login. Please try again" })
        }
      }
    }, authChannel)
  }

  requiredInputProvided = () => (
    !!this.state.email && !!this.state.password
  )

  render() {
    const { from } = this.props.location.state || { from: '/dashboard' }
    const { redirectToReferrer } = this.state

    if (redirectToReferrer) {
      return (
        <Redirect to={from} />
      )
    }

    return (
      <div className="slds-grid slds-grid--vertical-align-center slds-grid--align-center">
        <section className="slds-m-bottom_xx-large">
          <br />
          <img src={logo} alt="MessagePlus Logo" style={{ height: '100px' }} />
          <hr />
          <div className="slds-text-heading_medium slds-text-align_center">
            Log in to your account
          </div>
          {this.state.error &&
            <div className='slds-p-bottom_small slds-text-color_error'>
              {this.state.error}
            </div>
          }
          <div className="slds-form slds-form--stacked">
            <div className="slds-form-element">
              <label className="slds-form-element__label" htmlFor="email">
                Email address
              </label>
              <div className="slds-form-element__control">
                <Input id="email" value={this.state.email} placeholder="Email" onChange={(e) => this.setState({email: e.target.value})} />
              </div>
            </div>
            <div className="slds-form-element">
              <label className="slds-form-element__label" htmlFor="password">Password</label>
              <div className="slds-form-element__control">
                <Input
                  id="password"
                  type="password"
                  value={this.state.password}
                  placeholder="Password"
                  onChange={(e) => this.setState({ password: e.target.value })}
                  title="Password"
                />
              </div>
            </div>
            <div className="slds-form-element slds-p-top_medium slds-size_1-of-1">
              <div>
                <Button
                  type='brand'
                  fullWidth={true}
                  disabled={!this.requiredInputProvided()}
                  onClick={() => this.login('default')}
                  title='Log in using MessagePlus account credentials'
                  style={{ width: '100%' }}>
                  Log in with MessagePlus
                </Button>
              </div>
              <div className='slds-m-top_x-small'>
                <Button
                  type='brand'
                  fullWidth={true}
                  disabled={!this.requiredInputProvided()}
                  onClick={() => this.login('worklight')}
                  title='Log in using WorkLight account credentials'
                  style={{ width: '100%', backgroundImage: 'linear-gradient(to right, #4dbae0, #89ce1e)' }}>
                  Log in with WorkLight
                </Button>
              </div>
            </div>
            <div className="slds-m-top_small">
              <div className="slds-text-body--regular slds-p-bottom_small">
                <NavLink to='/password/reset'>I forgot my password.</NavLink>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default withApollo(Login)



// WEBPACK FOOTER //
// ./src/containers/Login.js